import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Backdrop } from "@/components/theme/Backdrop";
import { GoldRule } from "@/components/theme/Reveal";

// Saklar: ubah ke true untuk menampilkan kembali Manajemen File dan Album Kustom.
const SHOW_MORE = false;

const Option = ({ to, title, desc, cta, delay, testId }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    <Link
      to={to}
      data-testid={testId}
      className="group relative flex h-full min-h-[280px] flex-col justify-between overflow-hidden border border-[#E8E3D9] bg-white/90 p-8 transition-all duration-500 hover:-translate-y-1 hover:border-[#C6A56B] hover:shadow-[0_22px_40px_-24px_rgba(198,165,107,0.65)] md:p-10"
    >
      {/* garis emas tipis di atas kartu */}
      <span className="absolute inset-x-0 top-0 h-px origin-left scale-x-0 bg-[#C6A56B] transition-transform duration-700 group-hover:scale-x-100" />
      <div>
        <h2 className="font-serif text-4xl font-light tracking-tight text-[#111111]">{title}</h2>
        <p className="mt-4 max-w-sm font-sans text-sm leading-relaxed text-[#8A8A8A]">{desc}</p>
      </div>
      <span className="relative mt-10 inline-flex items-center gap-3 self-start font-sans text-sm uppercase tracking-widest text-[#111111]">
        {cta}
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5 group-hover:text-[#C6A56B]" />
        <span className="absolute -bottom-1.5 left-0 h-px w-full origin-left scale-x-0 bg-[#C6A56B] transition-transform duration-500 group-hover:scale-x-100" />
      </span>
    </Link>
  </motion.div>
);

export default function Landing() {
  return (
    <div className="relative isolate flex min-h-screen flex-col justify-center bg-[#F9F8F6] px-6 py-16 md:px-12 lg:px-20">
      <Backdrop />
      <div className="mx-auto w-full max-w-6xl">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="font-sans text-sm uppercase tracking-[0.5em] text-[#111111]"
        >
          DIRGA
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-8 font-serif text-5xl font-light leading-[1.05] tracking-tight text-[#111111] sm:text-6xl lg:text-7xl"
        >
          Build Your Wedding Story
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.22 }}
          className="mt-6 max-w-xl font-serif text-xl italic text-[#5C5C5C] sm:text-2xl"
        >
          Pilih yang kamu butuhkan untuk harimu.
        </motion.p>
        <GoldRule className="mt-8" />

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2">
          <Option
            testId="option-builder"
            to="/builder"
            title="Wedding Builder"
            desc="Susun paket foto dan video pernikahanmu sendiri dan lihat estimasi biayanya secara langsung."
            cta="Mulai Menyusun"
            delay={0.34}
          />
          <Option
            testId="option-album"
            to="/album/buat"
            title="Ruang Kenang"
            desc="Satu album digital untuk semua foto tamu. Tamu scan QR, ambil foto, dan semuanya masuk ke albummu."
            cta="Buat Ruang Kenang"
            delay={0.46}
          />
          {SHOW_MORE && (
            <>
              <Option
                testId="option-files"
                to="/berkas"
                title="Manajemen File"
                desc="Kumpulan foto dan video pernikahanmu dalam satu tempat. Lihat, unduh, dan simpan semua hasilnya."
                cta="Buka Berkas"
                delay={0.58}
              />
              <Option
                testId="option-custom-album"
                to="/album/custom"
                title="Album Kustom"
                desc="Susun albummu sendiri dari foto yang sudah ada. Pilih, atur urutan, dan jadikan cerita versimu."
                cta="Buat Album Kustom"
                delay={0.7}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
